import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PermitDetail } from '../../../models/permit-detail.model';

/** Tourist Pass detail - no fields beyond the common set (yet). */
@Component({
    selector: 'app-tourist-pass-detail',
    template: `<app-permit-common-details [permit]="permit"></app-permit-common-details>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TouristPassDetailComponent {
    @Input() permit!: PermitDetail;
}
